(function() {
  'use strict';

  var sidebarCards = [
    'GeneralCards',
    'EventsCards',
    'GoalsCards',
    'BulkActionCards',
    'UsersCards',
    'SettingsCards',
    'EmailTemplatesCards',
    'InboxCards'
  ];

  angular.module('layout.sidebar')
    .constant('SIDEBAR_CARDS', sidebarCards);
})();
